const VOTE_ENDPOINT = (pollId, optionId) => `/api/poll/${pollId}/vote/${optionId}`;

const TEMPLATE_IMAGE = "1";
const TEMPLATE_TEXT = "2";

const Api = {
    vote(pollId, optionId) {
        return fetch(VOTE_ENDPOINT(pollId, optionId),{ method: 'POST' })
            .then(res => {
                const { ok } = res;
                if (!ok) {
                    throw new Error(`Error voting ${pollId} poll`);
                }
                return res.json()
            })
            .then(res => res);
    }
};

export {
    TEMPLATE_TEXT,
    TEMPLATE_IMAGE
}

export default Api;